import { render, staticRenderFns } from "./MAssignToUser.vue?vue&type=template&id=1cfe94b4&scoped=true&lang=pug&"
import script from "./MAssignToUser.vue?vue&type=script&lang=js&"
export * from "./MAssignToUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe94b4",
  null
  
)

export default component.exports